import { Grid, Tabs } from '@mantine/core';
import { Security2FA } from './Security2FA';
import { SecurityLinkedCard } from './SecurityLinkedCard';
import { SecurityPasswordCard } from './SecurityPasswordCard';
import { SecuritySession } from './SecuritySession';
export const AccountSecurityTab = () => {
  return <Tabs.Panel value="security">
      <Grid gutter={20}>
        <Grid.Col span={{
        base: 12,
        lg: 6
      }}>
          <SecurityPasswordCard />
          <SecurityLinkedCard />
        </Grid.Col>
        <Grid.Col span={{
        base: 12,
        lg: 6
      }}>
          <Security2FA />
        </Grid.Col>
        <Grid.Col span={12}>
          <SecuritySession />
        </Grid.Col>
      </Grid>
    </Tabs.Panel>;
};